var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk-sub-control d-flex"},[_c('ObservatoryControlLayer'),(
      _vm.Risk.RAIN.key === _vm.selectedRisk.key ||
        _vm.Risk.DOSYA.key === _vm.selectedRisk.key ||
        _vm.Risk.SNOW.key === _vm.selectedRisk.key ||
        _vm.Risk.RIVER_FLOODING.key === _vm.selectedRisk.key
    )?_c('v-card',{staticClass:"align-self-start ml-2 pa-2",attrs:{"width":100}},[_c('LayerOpacityControl')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }